import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { CreateTeamRequest, DeleteTeamRequest, UpdateTeamRequest, ViewTeamRequest } from './team.types';

import { requestCreateTeam, requestDeleteTeam, requestUpdateTeam, requestViewTeam } from './team.actions';

export const useTeamApi = () => {
  const dispatch = useDispatch();

  const createTeam = useCallback(
    (requestData: CreateTeamRequest, onSuccess?: () => void) => {
      dispatch(requestCreateTeam({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewTeam = useCallback(
    (requestData: ViewTeamRequest) => {
      dispatch(requestViewTeam({ requestData }));
    },
    [dispatch]
  );

  const updateTeam = useCallback(
    (requestData: UpdateTeamRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateTeam({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deleteTeam = useCallback(
    (requestData: DeleteTeamRequest, onSuccess?: () => void) => {
      dispatch(requestDeleteTeam({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { createTeam, viewTeam, updateTeam, deleteTeam };
};
